import type { FC } from 'react'
import { useState } from 'react'

import CheckboxBlankOutlineIcon from 'mdi-react/CheckboxBlankOutlineIcon'
import CheckboxMarkedOutlineIcon from 'mdi-react/CheckboxMarkedOutlineIcon'

import { useText } from '@/app/translations/translations-hooks'
import type { Policy } from '@/resources/ecom-policy'

const AllPoliciesCheckbox: FC<{
  policyList: Policy[]
  selectedPolicyIds: number[] | null
  onPoliciesSelect: (v: number[] | null) => void
}> = ({ policyList, selectedPolicyIds, onPoliciesSelect }) => {
  const policyIdList = policyList?.map(({ id }) => id)
  const [fullPolicyIdList] = useState(policyIdList)
  const isSelected =
    policyIdList.length > 0 && !policyIdList?.find(id => !selectedPolicyIds?.includes(id))

  const text = useText('select all')

  const handleClick = () => {
    const filteredList = fullPolicyIdList.filter(
      id => !policyIdList.includes(id) && selectedPolicyIds?.includes(id)
    )

    if (isSelected) {
      onPoliciesSelect(filteredList.length ? filteredList : null)
      return
    }

    onPoliciesSelect([...policyIdList, ...filteredList])
  }

  return (
    <th onClick={handleClick} className={`${isSelected ? 'selected' : ''}`}>
      <div className="check-mark" title={text}>
        {isSelected ? <CheckboxMarkedOutlineIcon /> : <CheckboxBlankOutlineIcon />}
      </div>
    </th>
  )
}

export default AllPoliciesCheckbox
